import { getUrl } from "aws-amplify/storage";
import { SchoolKindEnum } from "common/enums/SchoolKindEnum";
import fetchClient from "common/functions/fetcher";
import { SchoolArea } from "common/interfaces/SchoolArea";
import { decode } from "geobuf";
import { PbfReader } from "pbf";
import { invokeGetPresignedUrlForAnonymous } from "../api/s3";

export const getSchoolAreas = async (
  prefCode: string,
  cityCode: string,
  schoolKind: SchoolKindEnum,
  forAnonymous: boolean
): Promise<SchoolArea | undefined> => {
  const jsonKey = `public/json/${prefCode}/schools/${cityCode}${
    schoolKind === SchoolKindEnum.ESchool ? "e" : "j"
  }.buf`;
  const jsonUrl = await (
    forAnonymous
      ? invokeGetPresignedUrlForAnonymous(jsonKey, "unauthenticated")
      : getUrl({
          path: jsonKey
        }).then((value) => value.url.href)
  ).catch(() => undefined);

  if (jsonUrl) {
    const response = await fetchClient
      .getCached<ArrayBuffer>(jsonUrl, {
        responseType: "arraybuffer"
      })
      .catch(() => undefined);

    if (response) {
      const pbf = new PbfReader(response.data);

      const geoJson = decode(pbf);

      return { ...geoJson } as SchoolArea;
    }
  }

  return undefined;
};
